import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { FACTURA, ORDEN_PRODUCCION, OTROS } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';

import requerimientoService from '../../../service/logistica/requerimientoService';
import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';
import proveedorService from '../../../service/administracion/proveedorService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import proyectoService from '../../../service/administracion/proyectoService';
import ordenProduccionService from '../../../service/logistica/ordenProduccionService';
import empleadoService from '../../../service/administracion/empleadoService';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import Header from '../../../components/Header';
import Filters from './Filters';
import FormModal from './FormModal';
import ResultList from './ResultList';
import BuscarProductoModal from './BuscarProductoModal';
import ImportarRequerimientoModal from './ImportarRequerimientoModal';
import FormModalVer from '../OrdenProduccion/FormModalVer';
import RenombrarProductoModal from './RenombrarProductoModal';
import ImprimirModal from './ImprimirModal';

import { APROBADO } from '../../../common/types/ordenProduccionEstadoType';
import { LOGISTICA_REQUERIMIENTO } from '../../../common/types/referenciaOrigenType';
import { APROBAR_OP, } from '../../../common/types/configuracionType';
import { LOGISTICA } from '../../../common/types/moduloType';

var referenciaCount = 1;
var formModalPorImportar = null;
var products = [];

export default class Index extends PaginationBase {

    constructor(props) {

        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            proyectos: [],
            requerimientos: [],
            proveedores: [],
            configuraciones: [],
            filter: {
                //nombre: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            importarRequerimientoVisible: false,
            visibleVer: false,
            renombrarProductoVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarRequerimientoModal: {
                nombre: '',
                dataSource: [],
                dataSourceDetalle: [],
                selectedRowKeys: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0
            },
            imprimirFormValues: {
                file: undefined,
                idOrdenProduccion: 0
            }
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            //fechaInicioStr: "",
            //fechaFinStr: '',
            //serie: '',
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleNew = async () => {
        debugger
        var idSoles = SOLES;
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === idSoles);
        formValues.establecimientos = this.state.establecimientos;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.proyectos = this.state.proyectos;
        formValues.proveedores = this.state.proveedores;
        formValues.productos = this.state.productos;
        formValues.recetas = this.state.productos;

        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: ORDEN_PRODUCCION.ID
        }
        const datosIniciales = await ordenProduccionService.datosIniciales(datosInicialesFilter);

        if (datosIniciales !== undefined) {
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
        }

        if (formValues.idEstablecimiento > 0) {
            const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            formValues.almacenes = almacenes ? almacenes : [];
        }

        var filterSearchReq = {
            idEstadoRequerimiento: APROBADO,
            filtro: ''
        };
        var productos = await productoService.productoPorlistarPorIdListaPrecio(2);
        //debugger
        this.setState({
            visible: true,
            formValues,
            productos: productos ? productos : [],
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: []
            },
            requerimientos: [],
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                selectedRowKeys: []
            }
        });
    }

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    }

    handleChangeForm = async (property, value, form) => {

        if (property === "idProveedor") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoProveedor: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
                });
            });
        }

        if (property === "idEstablecimiento") {
            debugger
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });
        }


        if (property === "fechaStr") {
            debugger
            console.log('cambio 1')
            var arrayD1 = value.split('/');
            //const dias_vencimiento = this.CalcularDiasVencimiento(value, this.state.formValues.fechaVencimientoStr);
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                    //diasVencimiento: dias_vencimiento,
                    fechaStr: value,
                    //minFechaStr: arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]
                }
            });
        }

        if (property === "fechaVencimientoStr") {
            const dias_vencimiento = this.CalcularDiasVencimiento(this.state.formValues.fechaStr, value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    diasVencimiento: dias_vencimiento,
                    fechaVencimientoStr: value
                }
            });
        }

        if (property === "diasVencimiento") {
            var arrayD1 = this.state.formValues.fechaStr.split('/');
            var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
            var fechaVencimiento = date1.setDate(date1.getDate() + parseInt(value));

            let day = date1.getDate()
            let month = date1.getMonth() + 1
            let year = date1.getFullYear()

            var fechaVencStr = '';

            if (month < 10) {
                fechaVencStr = `${day}/0${month}/${year}`;
            } else {
                fechaVencStr = `${day}/${month}/${year}`;
            }

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fechaVencimientoStr: fechaVencStr
                }
            });
        }

        if (property === "idMoneda") {
            const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listasPrecio: listasPrecio ? listasPrecio : []
                }
            });
        }

        if (property === "idListaPrecio") {
            const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listasPrecio: listasPrecio ? listasPrecio : []
                }
            });
        }
    }

    CalcularDiasVencimiento = (fecha_1, fecha_2) => {
        var arrayD1 = fecha_1.split('/');
        var arrayD2 = fecha_2.split('/');

        var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
        var dateFV = new Date(arrayD2[2] + "/" + arrayD2[1] + "/" + arrayD2[0]);

        var Difference_In_Time = dateFV.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

        return Difference_In_Days;
    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = () => {
        if (this.state.formValues.activeKey === "1")
            this.handleBuscarProducto();

        if (this.state.formValues.activeKey === "2")
            this.handleAddReferencia();
    };

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: referenciaCount,
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: false
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (id) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            },
        });
    }

    handleBuscarProducto = () => {
        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: this.state.productos
            }
        });
    }

    handleImportarRequerimiento = async () => {
        var filterSearchReq = {
            idEstadoRequerimiento: APROBADO,
            filtro: ''
        };
        var requerimientos = await requerimientoService.listarPorEstado(filterSearchReq);
        this.setState({
            importarRequerimientoVisible: true,
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: requerimientos ? requerimientos : [],
                dataSourceDetalle: []
            }
        })
    }

    handleChangeProductoModal = (value) => {
        const dataSource = this.state.productos.filter(item => {
            return (item.codigoReferencia + ' - ' + item.nombre)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            productoModal: {
                ...this.state.productoModal,
                dataSource: dataSource
            }
        });
    };

    handleChangeSelectedRowKey = (selected, rows) => {
        debugger
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        rows.forEach(item => {
            var filter = this.state.formValues.listaComprobanteDetalle.filter(m => { return m.idProducto === item.id; });
            if (filter.length === 0) {

                listaComprobanteDetalle.push({
                    idProducto: item.id,
                    nombre: item.nombre,
                    cantidad: 0,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: 0,
                    total: 0,
                    flagAfecto: item.flagIGVAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: 0,
                    igv: 0
                })
            }
        });

        listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selected
            }
        });
    };

    handleRemoverProducto = (id) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== id);
        var selectedRowKeys = this.state.productoModal.selectedRowKeys.filter(m => m !== id);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selectedRowKeys
            }
        });
    };

    handleOnChangeProveedor = async (value) => {
        console.log(value);
        debugger
        var numDoc = value.label.split('-')[value.label.split('-').length - 1];
        console.log(value.label);

        this.setState({
            formValues: {
                ...this.state.formValues,
                documentoProveedor: numDoc
            }
        });

        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(value.key);
        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //proveedorLoading: false,
                    //proveedores: [],
                    direcciones: [],
                }
            });
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //proveedorLoading: false,
                    //proveedores: resultFilter//.proveedores,
                    direcciones: direccionesEstablecimientos,
                    documentoProveedor: numDoc
                    //idProveedor: response.proveedores.length > 0 ? response.proveedores[0].id : 0,
                    //idEstablecimientoProveedor: response.direcciones.length > 0 ? response.direcciones[0].id : 0
                }
            });
        }
    }

    handleBuscarProveedor = async (value) => {

        if (value.length > 2) {


            this.setState({ formValues: { ...this.state.formValues, proveedorLoading: true } });

            const filter = {
                numeroDocumento: value,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }

            const response = await proveedorService.obtenerTodos(filter);

            if (response === undefined) {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        proveedorLoading: false,
                        proveedores: [],
                        direcciones: [],
                    }
                });
            }
            else {
                debugger
                const resultFilter = response.filter(item => {
                    return (item.numeroDocumento + ' - ' + item.nombre)
                        .toUpperCase()
                        .match(value.toUpperCase());
                });

                var direccionesEstablecimientos = [];
                if (resultFilter.length === 1) {
                    direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(resultFilter[0].idEntidad);
                }

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        proveedorLoading: false,
                        proveedores: resultFilter,
                        idProveedor: resultFilter.length === 1 ? resultFilter[0].idEntidad : 0,
                        direcciones: direccionesEstablecimientos,
                        idEstablecimientoProveedor: direccionesEstablecimientos.length === 1 ? direccionesEstablecimientos[0].id : 0,
                        documentoProveedor: resultFilter.length === 1 ? resultFilter[0].numeroDocumento : ''
                    }
                });
            }

        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    proveedorLoading: false,
                    proveedores: [],
                    direcciones: [],
                }
            });
        }

    };

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.idProducto
            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {
        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== value.idProducto);

        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === value.idProducto)[0];
        currentRow.nombre = value.nombre;
        //console.log(currentRow)
        listaComprobanteDetalle_aux.push(currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();

        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger

            if (values.ordenProduccionDetalles !== undefined) {
                for (var i = 0; i < values.ordenProduccionDetalles.length; i++) {
                    var item = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === values.ordenProduccionDetalles[i].idProducto)[0];
                    values.ordenProduccionDetalles[i].nombre = item.nombre;
                }
            }

            var response;
            if (values.id === 0 || values.id === undefined)
                response = await ordenProduccionService.registrar(values);
            else
                response = await ordenProduccionService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValuesDos();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEdit = async (values) => {
        const response = await ordenProduccionService.obtenerPorId(values.id);
        if (response !== undefined) {
            debugger
            var formValues = this.fetchEditFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
            formValues.establecimientos = this.state.establecimientos;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.almacenes = await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);


            const filterSearchProveedor = {
                numeroDocumento: formValues.documentoProveedor,
                idTipoComprobante: OTROS.ID
            }
            const responseProveedores = await proveedorService.obtenerTodos(filterSearchProveedor);
            const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(response.ordenProduccion.idEntidadProveedor);

            formValues.proveedores = responseProveedores;
            formValues.direcciones = direccionesEstablecimientos;

            var filterSearchReq = {
                idEstadoRequerimiento: APROBADO,
                filtro: ''
            };
            //var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
            // var requerimientos = await requerimientoService.listarPorEstado(filterSearchReq);
            //formValues.requerimientos = requerimientos;

            console.log(responseProveedores);
            console.log(direccionesEstablecimientos);


            const products = [];
            for (var i = 0; i < response.ordenProduccionDetalles.length; i++) {
                var item = response.ordenProduccionDetalles[i];
                var oneProd = {
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            for (var i = 0; i < response.ordenProduccionReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenProduccionReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            referenciaCount = response.ordenProduccionReferencias.length + 1;

            var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);

            console.log(formValues);

            this.setState({
                visible: true,
                formValues,
                productos: productos ? productos : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: products// []
                },
                requerimientos: [],
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    selectedRowKeys: []
                }
            });

        }
    }

    handleVer = async (values) => {
        const response = await ordenProduccionService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);

            for (var i = 0; i < response.ordenProduccionDetalles.length; i++) {
                var item = response.ordenProduccionDetalles[i];
                var oneProd = {
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.ordenProduccionReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenProduccionReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visibleVer: true,
                formValues
            });
        }
    }

    fetchMinCurrentDateStr(firstDayOfTheMonth) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = firstDayOfTheMonth === true ? '01' : String(date.getDate()).padStart(2, '0');
        return yyyy + '/' + mm + '/' + dd;
    };

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idProveedor: 0, //..........................................................OK
            idEstablecimientoProveedor: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: "OP01",
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            minFechaStr: this.fetchMinCurrentDateStr(),
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            documentoProveedor: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            proveedores: [],
            idRequerimiento: 0,
            productos: [],
            recetas: [],
            idReceta: 0,
            idProductoTerminado: 0,
            cantidad: 0,
        }
    };

    fetchEmptyFormValuesDos = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idProveedor: 0, //..........................................................OK
            idEstablecimientoProveedor: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: 'OC01', //............................................... OK
            documento: "", //............................................... OK
            //fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            //fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            documentoProveedor: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            proveedores: [],
            idRequerimiento: 0,
            productos: [],
            recetas: [],
            idReceta: 0,
            idProductoTerminado: 0,
            cantidad: 0,
        }
    };

    fetchEditFormValues = (value) => {
        console.log(value);
        debugger
        return {
            id: value.ordenProduccion.id,
            idProveedor: value.ordenProduccion.idProveedor, //..........................................................OK
            idEstablecimientoProveedor: value.ordenProduccion.idEstablecimientoProveedor, //..........................................................OK
            idAlmacen: value.ordenProduccion.idAlmacen, //..........................................................OK
            idMoneda: value.ordenProduccion.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.ordenProduccion.idEstablecimiento,
            idProyecto: value.ordenProduccion.idProyecto,
            serie: value.ordenProduccion.serie, //............................................... OK
            documento: value.ordenProduccion.documento, //............................................... OK
            documentoProveedor: value.ordenProduccion.documentoProveedor,
            fechaStr: value.ordenProduccion.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.ordenProduccion.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.ordenProduccion.diasVencimiento, //..........................................................OK
            tipoCambio: value.ordenProduccion.tipoCambio, //..........................................................OK
            observacion: value.ordenProduccion.observacion, //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: value.ordenProduccion.subTotal,
            sumaIgv: value.ordenProduccion.igv,
            sumaTotal: value.ordenProduccion.total,
            //almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            //vendedores: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
            proyectos: [],
            proveedores: [],
            idRequerimiento: 0,

            /*Para la opcion ver*/
            nombreMoneda: value.ordenProduccion.nombreMoneda,
            nombreProyecto: value.ordenProduccion.nombreProyecto,
            nombreAlmacen: value.ordenProduccion.nombreAlmacen,
            proveedor: value.ordenProduccion.proveedor,
            direccionEstablecimiento: value.ordenProduccion.direccionEstablecimiento,
            nombreEstablecimientoSucursal: value.ordenProduccion.nombreEstablecimientoSucursal
        }
    }

    fetchImportarRequerimientoFormValues = (value) => {
        //console.log(value);
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: value.ordenProduccion.id,
            //idTipoComprobante: FACTURA.ID,
            idProveedor: value.ordenProduccion.idProveedor, //..........................................................OK
            idEstablecimientoProveedor: value.ordenProduccion.idEstablecimientoProveedor, //..........................................................OK
            //idVendedor: 0, //..........................................................OK
            idAlmacen: value.ordenProduccion.idAlmacen, //..........................................................OK
            idMoneda: value.ordenProduccion.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idProyecto: value.ordenProduccion.idProyecto,
            //idComprobanteEstado: 0,
            //idEstablecimiento: 0, //..........................................................OK
            //idDetraccion: 0, //..........................................................OK
            //idUsuarioRegistro: 0,
            serie: 'OP01', //............................................... OK
            documento: value.ordenProduccion.documento, //............................................... OK
            documentoProveedor: value.ordenProduccion.documentoProveedor,
            fechaStr: value.ordenProduccion.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.ordenProduccion.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.ordenProduccion.diasVencimiento, //..........................................................OK
            //numeroPlaca: "", //..........................................................OK
            tipoCambio: value.ordenProduccion.tipoCambio, //..........................................................OK
            observacion: value.ordenProduccion.observacion, //..........................................................OK
            //flagExportacion: false, //..........................................................OK
            //flagPercepcion: false, //..........................................................OK
            //flagDetraccion: false, //..........................................................OK
            //flagAnticipo: true,
            //flagGrifo: true,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: value.ordenProduccion.subTotal,
            sumaIgv: value.ordenProduccion.igv,
            sumaTotal: value.ordenProduccion.total,
            //porcentajeDetraccion: 0,
            //importeDetraccion: 0,
            //totalDetraccion: 0,
            //porcentajePercepcion: 0,
            //importePercepcion: 0,
            //totalPercepcion: 0,
            //totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            //flagEmpresaGrifo: auth.user().parametros.filter(m => m.abreviatura === EMPRESA_GRIFO)[0].valor === "1" ? true : false,
            //almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            documentoProveedor: value.ordenProduccion.documentoProveedor,
            monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            //vendedores: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
            proyectos: []
        }
    }

    handleSelectedRowRequerimientoPorImportar = async (selected, rows) => {

        var arraySelect = [];
        const idReqImport = selected[selected.length - 1];
        const response = await requerimientoService.obtenerPorId(idReqImport);

        arraySelect.push(idReqImport);

        if (response !== undefined) {

            var formValues = this.fetchEmptyFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
            formValues.establecimientos = this.state.establecimientos;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.idRequerimiento = idReqImport;

            if (this.state.formValues.id !== undefined && this.state.formValues.id > 0) {
                formValues.id = this.state.formValues.id;
                formValues.serie = this.state.formValues.serie;
                formValues.documento = this.state.formValues.documento;
            }

            products = [];
            for (var i = 0; i < response.requerimientoDetalles.length; i++) {
                var item = response.requerimientoDetalles[i];
                var oneProd = {
                    id: item.id,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,

                    precioUnitario: 0,
                    total: 0,
                    flagAfecto: item.flagIGVAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: 0,
                    igv: 0
                }
                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            var itemRefReq = {
                identifier: 1,
                idReferencia: response.requerimiento.id,
                idReferenciaOrigen: LOGISTICA_REQUERIMIENTO,
                idTipoComprobante: 88,
                serie: response.requerimiento.serie,
                documento: response.requerimiento.documento,
                flagInterno: true
            }
            formValues.listaComprobanteReferencia.push(itemRefReq);
            // referenciaCount = 2;

            // for (var i = 0; i < response.requerimientoReferencias.length; i++) {

            //     var item = response.requerimientoReferencias[i];
            //     var oneRef = {
            //         identifier: referenciaCount,
            //         idReferencia: item.id,
            //         idReferenciaOrigen: item.idReferenciaOrigen,
            //         idTipoComprobante: item.idTipoComprobante,
            //         serie: item.serie,
            //         documento: item.documento,
            //         flagInterno: true
            //     }
            //     referenciaCount = referenciaCount + 1;
            //     formValues.listaComprobanteReferencia.push(oneRef);
            // }

            formModalPorImportar = formValues;

            this.setState({
                importarRequerimientoVisible: true,
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    dataSourceDetalle: formValues.listaComprobanteDetalle,
                    selectedRowKeys: arraySelect//selected
                }
            })
        }
    }

    handleOkImportarRequerimiento = (values, form) => {
        console.log('ko');
        var idSoles = SOLES;
        formModalPorImportar.monedas = this.state.monedas;
        formModalPorImportar.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formModalPorImportar.listasPrecio = this.state.listasPrecio.filter(m => m.id === idSoles);
        formModalPorImportar.establecimientos = this.state.establecimientos;
        formModalPorImportar.idListaPrecio = formModalPorImportar.listasPrecio.length === 0 ? 0 : formModalPorImportar.listasPrecio[0].id;
        formModalPorImportar.tiposComprobante = this.state.tiposComprobante;
        formModalPorImportar.proyectos = this.state.proyectos;
        formModalPorImportar.activeKey = "2";

        this.setState({
            importarRequerimientoVisible: false,
            //importarRequerimientoModal: {
            //    ...this.state.importarRequerimientoModal
            //},
            //formValues: formModalPorImportar
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: formModalPorImportar.listaComprobanteDetalle,
                listaComprobanteReferencia: formModalPorImportar.listaComprobanteReferencia,
                sumaSubTotal: 0,
                sumaIgv: 0,
                sumaTotal: 0,
                idRequerimiento: formModalPorImportar.idRequerimiento,
                activeKey: "2",
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: products
            }
            //...this.state.formValues,
            //listaComprobanteDetalle: formModalPorImportar.listaComprobanteDetalle,
            //listaComprobanteReferencia: formModalPorImportar.listaComprobanteReferencia
        })

    }

    handleAnular = async (values) => {
        var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_OP).length >= 1 ? true : false;

        if (!flagAnular) {
            message.warning('Usted no puede anular Orden de Producción.');
            return false;
        }
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                idOrdenProduccion: values.id,
                codOrdenProduccionEstado: 'AN',
                observacionRechazado: ''
            };
            var response = await ordenProduccionService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleChangeRequerimientoModal = (value) => {
        const dataSource = this.state.requerimientos.filter(item => {
            return (item.serie + ' - ' + item.documento)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: dataSource
            }
        });
    };

    handleExportExcel = async () => {
        this.setState({ loadingPdf: true });
        var response = await ordenProduccionService.excel(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Produccion.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await ordenProduccionService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Produccion.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await ordenProduccionService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleImprimir = async (item) => {

        var file = undefined;
        var response = await ordenProduccionService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idOrdenProduccion: item.id
            }
        });
    };

    async componentDidMount() {
        var idUsuario = auth.user().id;

        this._initPagination(this.state.filter, ordenProduccionService.paginacion);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const proyectos = await proyectoService.listar();
        const empleado = await empleadoService.listar();
        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: LOGISTICA });

        const productos = await productoService.listar();
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);

        this.setState({
            loadingSource: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            establecimientos: establecimientos ? establecimientos : [],
            vendedores: vendedores ? vendedores : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            proyectos: proyectos ? proyectos : [],
            proveedores: empleado ? empleado : [],
            productos: productos_filter ? productos_filter : [],

        });
    }



    render() {
        //debugger
        return (
            <div>
                <Header
                    title="Orden de Produccion"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onVer={this.handleVer}
                    onEditar={this.handleEdit}
                    onAnular={this.handleAnular}
                    onImprimir={this.handleImprimir}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarProveedor={this.handleBuscarProveedor}
                    onChangeProveedor={this.handleOnChangeProveedor}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onImportarRequerimiento={this.handleImportarRequerimiento}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onBlur={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                />
                <BuscarProductoModal
                    visible={this.state.productoVisible}
                    formValues={this.state.productoModal}
                    onChange={this.handleChangeProductoModal}
                    onChangeRow={this.handleChangeSelectedRowKey}
                    onCancel={() => this.setState({ productoVisible: false })}
                />
                <ImportarRequerimientoModal
                    visible={this.state.importarRequerimientoVisible}
                    formValues={this.state.importarRequerimientoModal}
                    onChangeRequerimientoModal={this.handleChangeRequerimientoModal}
                    onChangeRow={this.handleSelectedRowRequerimientoPorImportar}
                    onCancel={() => this.setState({ importarRequerimientoVisible: false })}
                    onHandleOkImportarRequerimiento={this.handleOkImportarRequerimiento}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
            </div>
        )
    }

}